import React from 'react';
import { UtensilsCrossed } from 'lucide-react';

const About = () => {
  return (
    <section id="about" className="py-24 bg-zinc-950">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          {/* Text Content */}
          <div className="space-y-6">
            <div className="inline-block mb-4">
              <UtensilsCrossed className="text-zinc-300" size={32} strokeWidth={1.5} />
            </div>
            <h2 className="text-5xl md:text-6xl font-light text-white leading-tight mb-6" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
              Our Story
            </h2>
            <div className="w-16 h-px bg-zinc-700 mb-6"></div>
            <p className="text-zinc-400 text-lg leading-relaxed font-light">
              We are your favourite local restaurant, inviting you to come together with your friends and family to share a delicious feast.
            </p>
            <p className="text-zinc-400 leading-relaxed font-light">
              Bring your friends and family to experience a delicious feast! Pazzo is a place for everyone. We bring to you the very best cooking: robust flavours, beautifully fresh produce, and an atmosphere you can't find anywhere else.
            </p>
            <p className="text-zinc-200 text-3xl font-light italic mt-8" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
              Mangiamo!
            </p>
          </div>

          {/* Image Grid */}
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-4">
              <div className="overflow-hidden">
                <img
                  src="https://images.unsplash.com/photo-1532117472055-4d0734b51f31?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxpdGFsaWFuJTIwcmVzdGF1cmFudHxlbnwwfHx8fDE3NjAwODgyMTB8MA&ixlib=rb-4.1.0&q=85"
                  alt="Italian Restaurant"
                  className="w-full h-72 object-cover hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="overflow-hidden">
                <img
                  src="https://images.pexels.com/photos/1566837/pexels-photo-1566837.jpeg"
                  alt="Pizza Making"
                  className="w-full h-56 object-cover hover:scale-105 transition-transform duration-700"
                />
              </div>
            </div>
            <div className="space-y-4 mt-12">
              <div className="overflow-hidden">
                <img
                  src="https://images.unsplash.com/photo-1593548615309-5a45c504f994?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwzfHxpdGFsaWFuJTIwcmVzdGF1cmFudHxlbnwwfHx8fDE3NjAwODgyMTB8MA&ixlib=rb-4.1.0&q=85"
                  alt="Italian Dining"
                  className="w-full h-56 object-cover hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="overflow-hidden">
                <img
                  src="https://images.unsplash.com/photo-1668686376776-df5a9b838896"
                  alt="Pizzeria"
                  className="w-full h-72 object-cover hover:scale-105 transition-transform duration-700"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;